<script lang="ts">
    import {OfferItem} from "../entities/OfferItem";
    import {LedExtras} from "../entities/LedExtras";

    export let offerItems: OfferItem[];
    export let currentItemIndex: number
    export let currentItem: OfferItem

    function getExtras(itemExtras) {
        if (!itemExtras) return
        const extras = []
        // TODO REIMPLEMENT THIS WITH NEW CHANGES
       /* Object.entries(itemExtras).forEach(([key, value]) => {
            if (value) {
                const label = document.querySelector("label[for='" + key + "'] > span").textContent
                extras.push(label)
            }
        })*/
        return extras
    }
</script>

<div class="self-center lg:self-start rounded-md px-8 py-2 mb-8 bg-blue-800 mt-12 sm:mt-24 xl:mt-12">
    <h2 class="p-2 w-full text-2xl font-semibold">Hozzáadott termékek</h2>
</div>
<div class="flex flex-wrap justify-center md:justify-around 2xl:justify-between m-2">
    {#each offerItems as model, i}
        <div class="rounded-2xl my-4 border-2 border-bg-600 bg-primary-100 hover:border-white transition p-4 cursor-pointer"
             style="width: 450px;" on:click={() => {
                currentItemIndex = i
                currentItem = model
                document.getElementById("info").scrollIntoView({ behavior: 'smooth'})
             }}>
            <div class="flex">
                <div class="rounded-xl">
                    <img src="/model_images/{model.measuredModel.model.id}.jpg" class="rounded-xl h-20"/>
                </div>
                <div class="flex flex-col items-start px-4">
                    <span class="font-semibold text-md">
                        {model.measuredModel.model.name}
                    </span>
                    <span>Szélesség: {model.widthValue} cm</span>
                    <span>Mélység: {model.projectionValue} cm</span>
                </div>
            </div>
            <div class="flex my-2 flex-col">
                <span>
                    <span class="font-semibold font-md pb-2">
                        Extrák
                    </span>

                </span>
                <div class="flex justify-start flex-wrap">
                    {#each model.getExtrasAsArray() as extra}
                    <span class="text-xs border border-white p-2 rounded-lg m-2 ml-0">
                       {extra}
                    </span>
                    {/each}
                </div>
            </div>
        </div>
    {/each}
    <div class="rounded-2xl bg-black my-4 bg-primary-100 border-2 border-primary-100 hover:border-white transition cursor-pointer"
         style="width: 450px;" on:click={() => {
        document.getElementById("model_"+currentItem.measuredModel.model.id).checked = false
        currentItemIndex = offerItems.length
        currentItem = currentItem.copy({model: null, extras: new LedExtras()})
    }}>
        <div class="flex items-center justify-center h-full p-2">
            <img src="/icons/add.svg" class="rounded-xl h-16 m-4"/>
            <span class="text-lg font-semibold">
                Új elemek felvétele az ajánlatkérésbe
            </span>
        </div>
    </div>
</div>
